export const MOTHER_LANG = 'languageCode';
export const PHONE = 'mobilePhone';
export const PERSON_ID = 'personId';
